import { render } from "./PbSchoolRelevancy.vue?vue&type=template&id=beb1b386&scoped=true"
import script from "./PbSchoolRelevancy.vue?vue&type=script&lang=js"
export * from "./PbSchoolRelevancy.vue?vue&type=script&lang=js"

import "./PbSchoolRelevancy.vue?vue&type=style&index=0&id=beb1b386&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb1b386"]])

export default __exports__